
// A generated file, substituting in the hashed filename of the iframe-inside code into the full URL
export function getIframeIndexJsUrl(specialFlavor) {
  const urlPrefix = 'https://cdn.fluidpreview.office.net/fluid/prod/hashed-assets/sourceless-iframe/';
  if (specialFlavor === 'serviceDeliveredDriver') {
      return urlPrefix + 'index.serviceDeliveredDriver.93bcee9c6fc8be3de87c.js';
  }
  // Otherwise default to bundled driver:
  return urlPrefix + 'index.bundledDriver.b931d3a5a58eba782f5f.js';
}